import React, { useEffect, useState } from "react";
import { ClipboardButton, SimpleButton } from "../../../../../components/buttons";
import LoaderSpinner from "../../../../../components/loader-spinner";
import { UrlContainer } from "./payment-url-style";
import { images } from "../../../../../assets";
import HiringServices from "../../../../../services/HiringServices";
import { PaymentUrlProps, PaymentUrlState } from "./payment-url-dto";

const PaymentUrl = ({ policyId }: PaymentUrlProps) => {
  const [paymentUrlState, setPaymentUrlState] = useState<PaymentUrlState>({
    url: "",
    error: "",
    msg: "",
    isLoading: false,
  });
  const { url, error, msg, isLoading } = paymentUrlState;

  const updatePaymentUrlState = (newState: Partial<PaymentUrlState>) => {
    setPaymentUrlState((prevState) => ({ ...prevState, ...newState }));
  };

  const getHealthPayUrl = async () => {
    updatePaymentUrlState({ error: "", isLoading: true });
    const response = await HiringServices.getPaymentUrl({
      loader: false,
      setLoading: () => {},
      policyId,
    });
    if ("ok" in response && response.ok) {
      updatePaymentUrlState({ url: response.url, msg: response.msg, error: "" });
    }
    if ("error" in response && response.error) {
      updatePaymentUrlState({ error: response.msg, url: "" });
    }
    updatePaymentUrlState({ isLoading: false });
  };

  useEffect(() => {
    getHealthPayUrl();
  }, [policyId]);

  return (
    <UrlContainer error={error} info={!!msg}>
      <div className="url-wrapper">
        <span className="url-title">Url paygold:</span>

        {isLoading && (
          <div className="url-loading">
            <LoaderSpinner />
          </div>
        )}

        {!isLoading && error && (
          <>
            <span className="url-error">
              Error al recuperar la URL de pago: {error}. Por favor, reintente
            </span>
            <SimpleButton
              text="Reintentar"
              icon={images.IconRetry}
              alt="icono reintentar"
              onClick={getHealthPayUrl}
            />
          </>
        )}

        {!isLoading && url && (
          <>
            <a href={url} target="_blank" rel="noopener noreferrer">
              {url}
            </a>
            <ClipboardButton text={url} />
          </>
        )}

        {!isLoading && !url && msg && (
          <span className="url-info">
            {msg}
          </span>
        )}
      </div>
    </UrlContainer>
  );
};

export default PaymentUrl;
